export default __webpack_public_path__ + "static/media/59.5f553386.jpeg";